import React from 'react'
import { useState } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector} from 'react-redux'

import commitmentSlice from '../../../state/slices/commitmentSlice'
import validatorSlice from '../../../state/slices/validatorSlice'
import TextArea from './TextArea'

const BackgroundInfoContainer = ({ backgroundDescriptionRef }) => {

    const [validated, setValidated] = useState(true)

    const { language, commitment, validators } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { changeBackgroundDescValidator } = bindActionCreators(validatorSlice.actions, dispatch)
    const { changeWhatsNew, changeBackgroundInfo } = bindActionCreators(commitmentSlice.actions, dispatch)

    const changeWhatsNewHandler = (language, content) => {
        changeWhatsNew({ language: language, content: content })
    }
    const changeBackgroundHandler = (language, content) => {
        changeBackgroundInfo({ language: language, content: content })
    }

    return(
        <div className="border-bottom">
            <TextArea
                commitment={commitment}
                target={`innovation_${language}`}
                title={'sit.commitment.whatNew'}
                maxLength={3500}
                toolTip={'sit.commitment.whatNewInfo'}
                validated={validated}
                setValidated={() => setValidated(true)}
                handleChange={changeWhatsNewHandler}
                language={language}
            />

            <div className="page-break-after"/>
            <div ref={backgroundDescriptionRef}>
                <TextArea
                    commitment={commitment}
                    target={`backgroundInformation_${language}`}
                    title={'sit.commitment.backgroundInfo'}
                    maxLength={3500}
                    toolTip={'sit.commitment.commitmentBackgroundInfo'}
                    reference={backgroundDescriptionRef}
                    validated={validators.background}
                    setValidated={() => changeBackgroundDescValidator(true)}
                    handleChange={changeBackgroundHandler}
                    language={language}
                />
            </div>
        </div>
    )
}

export default BackgroundInfoContainer


// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/BackgroundInfoContainer.jsx